import { withToman } from '@rahtab/system/lib/tools/string';
import { Card, CardCaption, CardContainer, Colors, getRadius, getSpacing, HorizontalLine, Text } from '@rahtab/ui';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { ReactElement } from 'react';
import type { Invoice } from 'rahtab-redux/slices/invoicesSlice';
import moment from 'moment-jalaali';

const BillingCard: React.VFC<BillingCardProps> = ({ id, items, from, to, total, cardAction, caption }) => {
  return (
    <Card style={styles.card}>
      <CardContainer>
        {caption}
        <View style={styles.container}>
          <CardCaption style={styles.rowView}>
            <Text variant="cardTitle" margin="none">
              صورت‌حساب
            </Text>
            <Text margin="none">
              {moment(to).format('jYYYY/jMM/jDD')} - {moment(from).format('jYYYY/jMM/jDD')}
            </Text>
          </CardCaption>
          <CardContainer>
            {items.map((item, index) => {
              const { quantity, title, total: itemPrice, unitText } = item;
              return (
                <View key={`${index}-${id}`}>
                  <Text color="description">
                    کارمزد تامین موجودی کالای <Text>{title}</Text>
                  </Text>
                  <View style={styles.rowView}>
                    <Text color="description" margin="none">
                      مقدار:{' '}
                      <Text variant="mediumBody">
                        {quantity} {unitText}
                      </Text>
                    </Text>
                    <Text color="description" margin="none">
                      مبلغ: <Text variant="mediumBody">{withToman(itemPrice)}</Text>
                    </Text>
                  </View>
                  {index !== items.length - 1 && <HorizontalLine style={{ marginTop: getSpacing() }} />}
                </View>
              );
            })}
          </CardContainer>
          <CardCaption color="lightGray" style={styles.rowView}>
            <Text color="description" margin="none">
              جمع کل:
            </Text>
            <Text variant="mediumBody" margin="none">
              {withToman(total)}
            </Text>
          </CardCaption>
        </View>
        {cardAction}
      </CardContainer>
    </Card>
  );
};

export default BillingCard;

const styles = StyleSheet.create({
  card: {
    margin: getSpacing(0.5),
  },
  container: {
    borderWidth: 0.75,
    borderRadius: getRadius(),
    borderColor: Colors.darkGray,
    marginBottom: getSpacing(),
    overflow: 'hidden',
  },
  rowView: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
});

interface BillingCardProps
  extends Omit<Invoice, 'hasRequestedOfficialSaleBill' | 'paidAt' | 'status' | 'statusText' | 'officialSaleBillUrl'> {
  cardAction?: ReactElement;
  caption?: ReactElement;
}
